import { render } from "./AttachUsersTableHeader.vue?vue&type=template&id=39079bd6"
import script from "./AttachUsersTableHeader.vue?vue&type=script&lang=js"
export * from "./AttachUsersTableHeader.vue?vue&type=script&lang=js"

import "./AttachUsersTableHeader.vue?vue&type=style&index=0&id=39079bd6&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__